/* HB 2026-10-12 (round 34, Vic: "if I have already selected L (on this or another product), then it should stay on this
   new chosen size without reload").
   The product page opens on her remembered size (localStorage "hb-size", written when she taps a size on a product
   page, in the quick add or in the cart), else M, else the nearest size in stock (assets/hb-pdp.js). The links on the
   site already point at M (snippets/hb-size-variant-url). When she has another size remembered, this points the link
   she taps at that size, in the same order as the product page (her size, M, L, S, XL, XS, XXL ...), just before the
   page leaves: a product card (collection, search, recommendations, recently viewed, the empty cart's lines) or a
   color dot on a product page, which loads the other color in place (assets/custom-quick-view.js). The page then
   arrives on her size and does not need to switch and download itself again. The sizes come from
   snippets/hb-size-variant-data in the element's data-hb-sizes; without it, or without a remembered size other than
   M, nothing changes. */

const RANK = ['M', 'L', 'S', 'XL', 'XS', 'XXL', 'XXS', 'XXXL', '3XL'];

function remembered() {
  try {
    return String(localStorage.getItem('hb-size') || '').trim().toUpperCase();
  } catch (_) {
    return '';
  }
}

function parse(text) {
  const out = { p: '', d: '', v: [] };
  String(text || '').split(';').forEach((part) => {
    const i = part.indexOf('=');
    if (i < 0) return;
    const key = part.slice(0, i);
    const val = part.slice(i + 1);
    if (key === 'p') out.p = val;
    else if (key === 'd') out.d = val;
    else if (key === 'v') {
      out.v = val.split('|').filter(Boolean).map((row) => {
        const f = row.split('~');
        return { id: f[0], ok: f[1] === '1', o: f.slice(2) };
      });
    }
  });
  return out;
}

const up = (s) => String(s == null ? '' : s).trim().toUpperCase();

function pick(data, size) {
  if (!data.v.length) return '';
  const order = [size].concat(RANK.filter((r) => r !== size));
  let v = data.v.find((x) => x.id === data.d) || data.v[0];
  for (let idx = 0; idx < v.o.length; idx++) {
    const values = Array.from(new Set(data.v.map((x) => up(x.o[idx]))));
    const letters = values.filter((x) => RANK.indexOf(x) !== -1).length;
    const mixed = values.some((x) => RANK.indexOf(x) === -1 && x !== 'ONE SIZE');
    if (!letters || mixed) continue;
    let hit = null;
    for (const r of order) {
      const c = data.v.find((c) => c.ok && up(c.o[idx]) === r && c.o.slice(0, idx).every((x, k) => x === v.o[k]));
      if (c) {
        hit = c.o[idx];
        break;
      }
    }
    if (hit === null) continue;
    const c = data.v.find((c) => c.o.every((x, k) => (k === idx ? x === hit : x === v.o[k])));
    if (c) v = c;
  }
  return v.id;
}

function withVariant(href, id) {
  try {
    const u = new URL(href, window.location.origin);
    if (u.origin !== window.location.origin || u.pathname.indexOf('/products/') === -1) return null;
    u.searchParams.set('variant', id);
    return u;
  } catch (_) {
    return null;
  }
}

function retarget(event) {
  const size = remembered();
  if (!size || size === 'M' || RANK.indexOf(size) === -1) return;
  const target = event.target;
  if (!target || !target.closest) return;
  const host = target.closest('[data-hb-sizes]');
  if (!host) return;
  const data = parse(host.getAttribute('data-hb-sizes'));
  const id = pick(data, size);
  if (!id) return;

  if (host.matches('product-swatch')) {
    // the color dot keeps its address in .url (assets/custom-quick-view.js reads it on the click that follows)
    const a = host.querySelector('a');
    const current = host.url || (a && a.getAttribute('href'));
    const u = current && withVariant(current, id);
    if (!u) return;
    const rel = u.pathname + u.search;
    host.url = rel;
    if (a) a.setAttribute('href', rel);
    return;
  }

  // a card or a line: every link in it to this product (not the other colors' dots)
  let path = data.p;
  try {
    path = new URL(data.p, window.location.origin).pathname;
  } catch (_) {
    /* keep */
  }
  host.querySelectorAll('a[href]').forEach((a) => {
    const u = withVariant(a.getAttribute('href'), id);
    if (!u || u.pathname !== path) return;
    a.setAttribute('href', u.pathname + u.search + u.hash);
  });
}

// pointerdown comes before the click (and before a long press or a right click opens the link elsewhere); click covers
// the keyboard. Both in the capture phase, so the theme's own handlers read the new address.
document.addEventListener('pointerdown', retarget, true);
document.addEventListener('click', retarget, true);
